import Fuse from 'fuse.js'

export const fuzzySearch = (ctx, e: any) => {
  const { fuse } = ctx

  if (e.searchTerm === '') {
    return {
      ...ctx,
      filteredUsers: [...ctx.users]
    }
  }

  const filteredUsers = fuse.search(e.searchTerm)

  return {
    ...ctx,
    filteredUsers
  }
}

export const createSearchIndex = ctx => {
  const options = {
    minMatchCharLength: 2,
    threshold: 0.3,
    keys: ['firstName', 'lastName']
  }

  const fuse = new Fuse(ctx.users, options)

  return {
    ...ctx,
    fuse
  }
}
